module.exports = __webpack_public_path__ + "static/media/arrow-right.ea9edfe5.svg";